const escapeVcf = (value = "") =>
  String(value)
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/;/g, "\\;");

export const vcf = (state, getters) => (contact) => {
  let vcf = "BEGIN:VCARD\nVERSION:4.0\n";
  vcf += `FN:${escapeVcf(contact.data.name)}\n`;
  vcf += `CATEGORIES:${escapeVcf(contact.type.label)}\n`;
  if (contact.data.company) {
    vcf += `ORG:${escapeVcf(contact.data.company)}\n`;
  }
  if (contact.position) {
    vcf += `TITLE:${escapeVcf(contact.position)}\n`;
  }
  if (contact.data.emails.length) {
    vcf +=
      contact.data.emails
        .map(({ type, address }) => {
          return `EMAIL;TYPE=${escapeVcf(type)}:${escapeVcf(address)}`;
        })
        .join("\n") + "\n";
  }
  if (contact.data.phones.length) {
    vcf +=
      contact.phones
        .map((phone) => {
          return `TEL;TYPE=${escapeVcf(phone.data.type)}:${escapeVcf(
            phone.vcard
          )}`;
        })
        .join("\n") + "\n";
  }
  if (contact.data.addresses.length) {
    vcf +=
      contact.data.addresses
        .map(({ type, street, city, state, country, zip }) => {
          const parts = [
            "", // PO Box
            "", // Extended
            escapeVcf(street),
            escapeVcf(city),
            escapeVcf(state),
            escapeVcf(zip),
            escapeVcf(country || "US"),
          ];
          return `ADR;TYPE=${escapeVcf(type)}:${parts.join(";")}`;
        })
        .join("\n") + "\n";
  }
  return vcf + "END:VCARD";
};

export const iif =
  () =>
  ({ salesLead, quote }) => {
    salesLead;
    quote;
    let iif =
      "!ACCNT	NAME	ACCNTTYPE	ACCNUM	EXTRA																						" +
      "ACCNT	Income	INC																								" +
      "ACCNT	Estimates	NONPOSTING	4	ESTIMATE																						" +
      "!INVITEM	NAME	INVITEMTYPE	DESC	PURCHASEDESC	ACCNT	ASSETACCNT	COGSACCNT	PRICE	COST	TAXABLE																" +
      "INVITEM	Item	PART			Income			50	0	N																" +
      "!CLASS	NAME	HIDDEN																								" +
      "CLASS	class	N																								" +
      "!CUST	NAME	BADDR1	BADDR2	BADDR3	BADDR4	BADDR5	SADDR1	SADDR2	SADDR3	SADDR4	SADDR5	PHONE1	PHONE2	FAXNUM	EMAIL	NOTE	CONT1	CONT2	CTYPE	TERMS	TAXABLE	SALUTATION	COMPANYNAME	FIRSTNAME	MIDINIT	LASTNAME" +
      "CUST	Customer	Customer																			N					" +
      "!TRNS	TRNSID	TRNSTYPE	DATE	ACCNT	NAME	CLASS	AMOUNT	DOCNUM	MEMO	CLEAR	TOPRINT	NAMEISTAXABLE	ADDR1	ADDR2	ADDR3	ADDR4	ADDR5	DUEDATE	TERMS	PAID	SHIPDATE					" +
      "!SPL	SPLID	TRNSTYPE	DATE	ACCNT	NAME	CLASS	AMOUNT	DOCNUM	MEMO	CLEAR	QNTY	PRICE	INVITEM	PAYMETH	TAXABLE	VALADJ	REIMBEXP	SERVICEDATE	OTHER2	OTHER3						" +
      "!ENDTRNS																										" +
      "TRNS		ESTIMATE	4/14/2001	Estimates	Customer		55	1		N	N	N	Customer					4/14/2001		N	4/14/2001					" +
      "SPL		ESTIMATE	4/14/2001	Income			-55			N		50	Item		N	N	NOTHING									" +
      "ENDTRNS																										";

    return iif;
  };
